import I18n from "lib/i18n/i18n";

export const getShipBackText = (key) => {
  return I18n.getString(`itemPage::shipBack::${key}`);
};

export const getStep = (state) => {
  return [
    "return_payment_waiting",
    "return_pending",
    "return_packaging",
    "return_scheduled",
    "return_shipping",
    "return_done",
  ].indexOf(state);
};

export const getFlowSteps = (state, direction, isReleaseFormSigned = false) => {
  const step = getStep(state);
  const isDirect = direction === "direct";
  const flowSteps = [
    {
      text: getShipBackText("shipmentConfirmed"),
      completed: step > 0,
      active: isDirect && isReleaseFormSigned,
    },
    {
      text: getShipBackText("shipmentPreparingReturn"),
      completed: step > 2,
      active: step === 1 || step === 2,
    },
    {
      text: getShipBackText("shipmentPackageReady"),
      completed: step > 3,
      active: step === 3,
    },
    {
      text: getShipBackText("shipmentPackageShipped"),
      completed: step > 4,
      active: step === 4,
    },
    {
      text: getShipBackText("shipmentPackageArrived"),
      completed: step > 4,
      active: false,
    },
  ];

  if (!isDirect) {
    return flowSteps;
  }

  return [
    {
      text: getShipBackText("shipmentSignForm"),
      completed: step > 0 || isReleaseFormSigned,
      active: step === 0,
    },
    ...flowSteps,
  ];
};

export const getFormattedAddress = (addressObj) => {
  if (!addressObj) {
    return null;
  }

  const {
    city = "",
    state = "",
    street = "",
    street2 = "",
    zipcode = "",
    country = "",
  } = addressObj;

  return `${street ? `${street}` : ""}${street2 ? `, ${street2}` : ""}${
    city ? `, ${city}` : ""
  }${state ? `, ${state}` : ""}${zipcode ? ` ${zipcode}` : ""}${
    country ? `, ${country}` : ""
  }`;
};

const getCustomRounding = (value) => {
  try {
    const [whole, decimal] = value.toString().split(".");

    const firstNotZeroDEcimal = decimal.search(/[1-9]/g);

    if (firstNotZeroDEcimal === -1) {
      return `${whole}.0`;
    }

    const multiplier = Math.pow(10, firstNotZeroDEcimal + 1);

    return `${Math.round(parseFloat(value) * multiplier) / multiplier}`;
  } catch (error) {
    return `0.0`;
  }
};

export const getDistanceString = (distance) => {
  if (!distance) {
    return null;
  }

  const { Value: value = "0.0", Units: unit = "mi" } = distance;
  const text = getShipBackText("distanceFromYourAddress");
  const rounded = getCustomRounding(value);

  return `${rounded}${unit} ${text}`.toLowerCase();
};

export const isShipBack = (item) => {
  const params = new URLSearchParams(window.location.search);

  return params.get("shipback") || false;
};

export const getDocumentId = (addresses) => {
  const params = new URLSearchParams(window.location.search);

  return params.get("document_id") || addresses.document_id;
};

export const setLsItemsShippingInfo = (shipBackInfo, newAddress) => {
  if (!shipBackInfo || !newAddress) {
    throw new Error("Failed to store address in ls");
  }

  const shipBackInfoLs = JSON.parse(localStorage.getItem("shipBack") || "{}");
  const { pendingAddresses = {} } = shipBackInfoLs;
  const { items } = shipBackInfo;

  const data = items.reduce((all, current) => {
    return {
      ...all,
      [current.public_id]: newAddress,
    };
  }, {});

  localStorage.setItem(
    "shipBack",
    JSON.stringify({
      ...shipBackInfoLs,
      pendingAddresses: { ...pendingAddresses, ...data },
    })
  );

  return data;
};

export const getLsItemShippingInfo = (itemId) => {
  const shipBackInfoLs = JSON.parse(localStorage.getItem("shipBack") || "{}");
  const { pendingAddresses = {} } = shipBackInfoLs;

  return pendingAddresses[itemId] || {};
};

export const clearLsItemsShippingInfo = (shipBackInfo) => {
  const shipBackInfoLs = JSON.parse(localStorage.getItem("shipBack") || "{}");
  const { pendingAddresses = {} } = shipBackInfoLs;
  const { items } = shipBackInfo;

  const data = items.reduce((all, current) => {
    return {
      ...all,
      [current.public_id]: undefined,
    };
  }, {});

  localStorage.setItem(
    "shipBack",
    JSON.stringify({
      ...shipBackInfoLs,
      pendingAddresses: { ...pendingAddresses, ...data },
    })
  );
};

export const gridClasses = {
  container: "shipBack--grid-container",
  item: "shipBack--grid-item",
};

export const getGoogleMapsDirectionLink = (origin = "", destination = "") => {
  return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`;
};

export const getSignedDocUrl = () =>
  window.location.href +
  "?document_id=f4ad90db1461425ca007baa81ffe9f6ff941e9b2";

export const getItemsDescriptions = (items) => {
  const itemsDescriptions = items.map((item) => item.description);

  return itemsDescriptions.join(", ");
};
